export enum SharedReportFiltersEnum {
    name = 'name',
    createdBy = 'createdBy'
}
